import { useMemo } from 'react';
import { ChatMessage, ChatConversation } from './useChat';

/** Formata data para exibição no separador */
const formatDateSeparator = (date: Date): string => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (isToday) return 'Hoje';
    if (isYesterday) return 'Ontem';

    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });
};

/** Retorna a chave de agrupamento da data (baseada no dia local) */
const getDateKey = (date: Date): string => {
    return date.toDateString();
};

export const useChatGroupedMessages = (conversation: ChatConversation | undefined) => {
    // Agrupa mensagens por dia
    const messagesWithDateSeparators = useMemo(() => {
        if (!conversation?.messages) return [];

        const result: { type: 'date' | 'message'; date?: string; message?: ChatMessage }[] = [];
        let lastDateKey = '';

        conversation.messages.forEach((msg) => {
            const msgDate = msg.timestamp ? new Date(msg.timestamp) : new Date();
            const dateKey = getDateKey(msgDate);

            if (dateKey !== lastDateKey) {
                result.push({
                    type: 'date',
                    date: formatDateSeparator(msgDate)
                });
                lastDateKey = dateKey;
            }

            result.push({ type: 'message', message: msg });
        });

        return result;
    }, [conversation?.messages]);

    return messagesWithDateSeparators;
};
